import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { Suspense } from "react";
import { LanguageProvider } from "@/contexts/LanguageContext";
import FullscreenLoader from "@/components/FullscreenLoader";
import SoftwareApplicationSchema from "@/components/seo/SoftwareApplicationSchema";
import ErrorBoundary from "@/components/ErrorBoundary";
import { CookieBanner } from "@/components/CookieBanner";
import { getConsentStatus, initPostHog } from "@/utils/cookieConsent";
import { ThemeProvider } from "@/contexts/ThemeContext";

// Un-lazied so the pre-rendered HTML hydrates without a Suspense gap on /.
import MarketingLanding from "./pages/MarketingLanding";
// Every non-marketing route lives inside AppShell, which carries its own
// import "./styles/app.css" (Tailwind + auth-app rules), the heavy
// providers (Auth, Tooltip, Toaster, ServiceUnavailableWrapper), AND the
// QueryClientProvider — marketing makes zero queries so vendor-query
// stays off the / critical path.
const AppShell = React.lazy(() => import("./AppShell"));

// Boot PostHog immediately if the user already granted consent in a previous session.
if (getConsentStatus() === 'granted') {
  initPostHog();
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <LanguageProvider>
            <SoftwareApplicationSchema />
            <CookieBanner />
            <Suspense fallback={<FullscreenLoader />}>
              <Routes>
                <Route path="/" element={<MarketingLanding />} />
                <Route path="*" element={<AppShell />} />
              </Routes>
            </Suspense>
          </LanguageProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
